<template>
	<div class="grow flex flex-col lg:flex-row items-start lg:items-center gap-0 lg:gap-3">
		<CountryFlag :iso="location.country.code" mode="rounded"/>
		<div class="grow flex flex-col items-start">
			<p>{{ locationFullName }}</p>
			<p class="text-gray-400 text-sm">{{ coordinates(location.lat, location.long) }}</p>
		</div>
	</div>
</template>
<script setup lang="ts">
import {coordinates} from '@/Helpers/general'
import {type Location} from '@/Types/Location'
import CountryFlag from '@dzangolab/vue-country-flag-icon'
import {ref, computed, type Ref, type ComputedRef, defineProps} from 'vue'

const props = defineProps<{
	location:Location,
}>()

const location: Ref<Location> = ref(props.location)

const locationFullName: ComputedRef<string> = computed((): string => {
	if(location.value){
		if(location.value.region){
			return `${location.value.name}, ${location.value.region.name}, ${location.value.country.name}`
		}
		return `${location.value.name}, ${location.value.country.name}`
	}
	return ''
})
</script>
